/**
 * Created by Tiger on 28/02/2022.
 */
import React, {useEffect, useMemo, useState} from 'react';
import {Form, Modal, Typography} from 'antd';
import i18n from 'i18next';
import {InputItem} from '../../components/inputItem';
import {SelectItem} from '../../components/select-item';
import {Footer, useMqttTest} from './util';

// MQTT 协议类型：mqtt 为明文，mqtts-ca 为 CA 签发证书
const PROTOCOL_MQTT = 'mqtt';
const PROTOCOL_MQTTS_CA = 'mqtts-ca';

export default function CustomMqttConfig(props) {
    const [protocol, setProtocol] = useState(PROTOCOL_MQTT);
    const [host, setHost] = useState('');
    const [port, setPort] = useState('');
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [clientId, setClientId] = useState('qingping-{mac}');
    const [topicUp, setUpTopic] = useState('qingping/{mac}/up');
    const [topicDown, setDownTopic] = useState('qingping/{mac}/down');
    const [testLoading, testMqtt] = useMqttTest();
    const protocolOptions = useMemo(() => [
        { label: i18n.t('mqtt_protocol_mqtt'), value: PROTOCOL_MQTT },
        { label: i18n.t('mqtt_protocol_mqtts_ca'), value: PROTOCOL_MQTTS_CA },
    ], []);
    const test = () => testMqtt({
        endpoint: `${ host }:${ port }`, username, password, clientId, topicUp, topicDown,
        ...(props.mqttsSupport ? { protocol } : {}),
    });
    const submit = () => props.onOk({
        mqttConfig: {
            host, port: Number(port), username, password, clientId, topicUp, topicDown,
            ...(props.mqttsSupport ? { protocol } : {}),
        },
    });


    // 不支持 MQTTS 时，强制回退为 mqtt
    useEffect(() => {
        if (!props.mqttsSupport && protocol !== PROTOCOL_MQTT) {
            setProtocol(PROTOCOL_MQTT);
        }
    }, [props.mqttsSupport]);

    useEffect(() => {
        if (typeof props?.config === 'object') {
            const {
                protocol = PROTOCOL_MQTT,
                host = '',
                port,
                username = '',
                password = '',
                clientId = 'qingping-{mac}',
                topicUp = 'qingping/{mac}/up',
                topicDown = 'qingping/{mac}/down',
            } = props.config;
            setProtocol(protocol);
            setHost(host);
            setPort(port);
            setUserName(username);
            setPassword(password);
            setClientId(clientId);
            setUpTopic(topicUp);
            setDownTopic(topicDown);
        }
    }, [props.config]);
    return (<>
        <Modal
            width={ document.body.clientWidth / 3 }
            title={ i18n.t('edit_mqtt_info_tip') }
            visible={ props.visible }
            maskClosable={ false }
            onCancel={ props.onCancel }
            onOk={ submit }
            footer={ <Footer
                onTest={ test }
                onCancel={ props.onCancel }
                onOk={ submit }
                testLoading={ testLoading }
            /> }
            closable={ true }
        >
            <>
                <Form style={ { marginBottom: 20 } }>
                    { props.mqttsSupport && <SelectItem
                        label={ i18n.t('mqtt_protocol') }
                        value={ { value: protocol } }
                        options={ protocolOptions }
                        onChanged={ ({ value }) => setProtocol(value) }
                        style={ { marginTop: 5 } }/> }
                    <InputItem
                        label={ 'Host' }
                        value={ host }
                        onChange={ event => setHost(event?.target.value.trim()) }/>
                    <InputItem
                        label={ 'Port' }
                        value={ port }
                        onChange={ event => setPort(event?.target.value.trim()) }/>
                    <InputItem
                        label={ 'User Name' }
                        value={ username }
                        onChange={ event => setUserName(event?.target?.value) }/>
                    <InputItem
                        label={ 'Password' }
                        value={ password }
                        onChange={ event => setPassword(event?.target?.value) }/>
                    <InputItem
                        label={ 'Client ID' }
                        value={ clientId }
                        onChange={ event => setClientId(event?.target?.value) }/>
                    <InputItem
                        label={ 'Up Topic' }
                        value={ topicUp }
                        onChange={ event => setUpTopic(event?.target?.value) }/>
                    <InputItem
                        label={ 'Down Topic' }
                        value={ topicDown }
                        onChange={ event => setDownTopic(event?.target?.value) }/>
                </Form>
                <Typography.Text>
                    { i18n.t('mqtt_tips') } <a target={ '_blank' }
                                               href={ '/private/access-instructions/#32-自建-mqtt-服务' }>{ i18n.t('mqtt_tips2') }</a>
                </Typography.Text>
            </>
        </Modal>
    </>);
}
